module.exports = __webpack_public_path__ + "img/noschedule.ebe28e9f.svg";